(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mv-promo-copy')) {
    customElements.define('mv-promo-copy', class extends HTMLElement {
      connectedCallback() {
        if (this.copyBound) return;
        this.copyBound = true;
        this.addEventListener('click', async (event) => {
          const button = event.target.closest('button[data-code]');
          if (!button || button.disabled) return;
          event.preventDefault();
          const code = button.dataset.code;
          button.disabled = true;
          let copied = false;
          try { await navigator.clipboard.writeText(code); copied = true; } catch (_) {
            const input = document.createElement('textarea');
            input.value = code; input.setAttribute('readonly', '');
            input.style.cssText = 'position:fixed;left:-9999px;top:0;';
            document.body.appendChild(input); input.select();
            try { copied = document.execCommand('copy'); } catch (_) {}
            input.remove(); button.focus({ preventScroll: true });
          }
          button.disabled = false;
          this.toggleAttribute('data-copied', copied);
          this.querySelector('.mv-promo-copy__status').textContent = copied ? 'Copié' : 'À copier manuellement';
          button.setAttribute('aria-label', copied ? 'Code BIENVENUE10 copié' : 'Copier le code BIENVENUE10');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
